import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { motion } from "framer-motion";
import { Sparkles, RefreshCcw, ChevronRight } from "lucide-react";

const KIND_COLORS = {
  game: "#CCFF00",
  music: "#FF9E80",
  watch: "#D4B3FF",
  prompt: "#A8E6FF",
  dare: "#FFC6FF",
};

export default function AIDirectorCard({ conversationId, onInject }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const refresh = async () => {
    if (!conversationId) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/ai/director/${conversationId}`);
      setItems(data.suggestions || []);
      setVisible(true);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { setVisible(false); setItems([]); }, [conversationId]);

  if (!visible && !loading) {
    return (
      <div className="px-3 pt-2 flex items-center gap-2" data-testid="director-preview">
        <button onClick={refresh} data-testid="director-open-btn"
          className="text-[11px] uppercase font-black tracking-widest bg-white border-hard-2 rounded-full px-3 py-1 press-btn flex items-center gap-1">
          <Sparkles strokeWidth={3} className="w-3.5 h-3.5" /> AI yönetmen önerileri
        </button>
      </div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }}
      className="px-3 pt-2 flex items-start gap-2 overflow-x-auto" data-testid="director-card">
      <div className="text-[10px] uppercase font-black tracking-widest text-[#555] pt-2 shrink-0">Yönetmen</div>
      {loading && <span className="text-xs text-[#555] py-2">…</span>}
      {items.map((s, i) => (
        <motion.button
          key={i}
          whileHover={{ y: -2 }}
          data-testid={`director-item-${i}`}
          onClick={() => onInject?.(s)}
          className="border-hard-2 rounded-xl px-3 py-2 shrink-0 text-left press-btn shadow-hard-sm"
          style={{ background: KIND_COLORS[s.kind] || "#FFF" }}
        >
          <div className="text-lg leading-none">{s.emoji}</div>
          <div className="text-xs font-black uppercase tracking-widest mt-1">{s.title}</div>
          <div className="text-[11px] text-[#333] mt-0.5 max-w-[180px]">{s.desc}</div>
        </motion.button>
      ))}
      <button onClick={refresh} data-testid="director-refresh-btn" className="w-9 h-9 border-hard-2 rounded-lg flex items-center justify-center press-btn shadow-hard-sm bg-white shrink-0">
        <RefreshCcw strokeWidth={3} className="w-4 h-4" />
      </button>
      <button onClick={() => setVisible(false)} className="text-[10px] uppercase font-black tracking-widest text-[#555] py-2 shrink-0">
        gizle <ChevronRight strokeWidth={3} className="inline w-3 h-3" />
      </button>
    </motion.div>
  );
}
